import { render, staticRenderFns } from "./incourse_wanting_list.vue?vue&type=template&id=23f96dca&"
import script from "./incourse_wanting_list.vue?vue&type=script&lang=js&"
export * from "./incourse_wanting_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports